import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../profile/constants';

const lazy = {
    WorkHistoryCreate: lazyLoad(async () => {
        const { WorkHistoryCreate } = await import('./EditWorkHistory');

        return { default: WorkHistoryCreate };
    }),
    WorkHistoryEdit: lazyLoad(async () => {
        const { WorkHistoryEdit } = await import('./EditWorkHistory');

        return { default: WorkHistoryEdit };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-work-history.title-add',
        page: lazy.WorkHistoryCreate,
        path: route.patterns.individualUser.workHistory.create,
    },
    {
        documentTitle: 'pages.user-work-history.title-edit',
        page: lazy.WorkHistoryEdit,
        path: route.patterns.individualUser.workHistory.edit,
    },
];
